// awsS3Config.js
import AWS from 'aws-sdk';

AWS.config.update({
  region: 'af-south-1',
});

const s3 = new AWS.S3({
  credentials: new AWS.CognitoIdentityCredentials({
    IdentityPoolId: 'af-south-1:47576c87-1fbb-47c1-a6ed-20bc6ada963d',
  }),
});

export { s3 };
